import { common, ECPointAttributeModel, InvalidFormatError, IOHelper, JSONHelper, toJSONAttributeUsage, } from '@neo-one/client-common';
import { AttributeBase } from './AttributeBase';
import { AttributeUsage } from './AttributeUsage';
export class ECPointAttribute extends AttributeBase(ECPointAttributeModel) {
    constructor({ usage, value }) {
        super({ usage, value });
        this.size = IOHelper.sizeOfUInt8 + IOHelper.sizeOfECPoint(this.value);
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        const { usage } = super.deserializeAttributeWireBase(options);
        if (!(usage === AttributeUsage.ECDH02 || usage === AttributeUsage.ECDH03)) {
            throw new InvalidFormatError(`Expected attribute usage to be ${AttributeUsage.ECDH02} or ${AttributeUsage.ECDH03}. Received: ${usage}`);
        }
        const value = common.bufferToECPoint(Buffer.concat([Buffer.from([usage]), reader.readBytes(32)]));
        return new this({ usage, value });
    }
    serializeJSON(_context) {
        return {
            usage: toJSONAttributeUsage(this.usage),
            data: JSONHelper.writeECPoint(this.value),
        };
    }
}

//# sourceMappingURL=ECPointAttribute.js.map
